import * as React from "react";
import { ProductType } from "swan-public-api-client";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { StreamingOpenTrades } from "./StreamingOpenTrades";
import { TradesGrid, Column, DefaultSpotFxColumns, DefaultColumns } from "./TradesGrid";
import { PaginationConfig } from "antd/lib/table";
import { AppState } from "../Store/RootReducer";
import { connect } from "react-redux";
import { FxRatesConsumer } from "../Api/FxRates";

interface PropsFromState {
  activeTradingAccountKey: string;
  activeTradingAccountType: ProductType;
}

interface TradeGridProps {
  columns?: Column[];
  bordered?: boolean;
  pagination?: PaginationConfig | false;
  title?: boolean | ((currentPageData: object[]) => React.ReactNode);
}

interface Props extends PropsFromState, WrappedComponentProps, TradeGridProps {}

function getColumns(props: Props): Column[] {
  if (props.columns !== undefined) {
    return props.columns;
  }

  switch (props.activeTradingAccountType) {
    case ProductType.SpotFX:
      return DefaultSpotFxColumns;
    default:
      return DefaultColumns;
  }
}

function ActiveTradingAccountStreamingOpenTradesGridCmp(props: Props) {
  return (
    <FxRatesConsumer>
      {fxRates => (
        <StreamingOpenTrades groupKey={props.activeTradingAccountKey} fxRates={fxRates} >
          {trades =>
            <TradesGrid
              trades={trades}
              columns={getColumns(props)}
              bordered={props.bordered}
              pagination={props.pagination}
              title={props.title}
              locale={{
                emptyText: props.intl.formatMessage({
                  id: "openTradesGrid.emptyText"
                })
              }}
            />
          }
        </StreamingOpenTrades>
      )}
    </FxRatesConsumer>
  );
}

const ActiveTradingAccountStreamingOpenTradesGridWithIntl = injectIntl(ActiveTradingAccountStreamingOpenTradesGridCmp);

const mapStateToProps = (state: AppState, ownProps: TradeGridProps): PropsFromState => {
  return {
    activeTradingAccountKey: state.activeTradingAccount.account!.Key,
    activeTradingAccountType: state.activeTradingAccount.account!.AccountType
  }
};

export const ActiveTradingAccountStreamingOpenTradesGrid = connect(mapStateToProps)(ActiveTradingAccountStreamingOpenTradesGridWithIntl);
